"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionPathGuard = sessionPathGuard;
const navigation_1 = require("next/navigation");
function sessionPathGuard({ session, key, group }) {
    if (session.calculatorKey !== key || (session.calculatorGroup ?? undefined) !== group) {
        (0, navigation_1.notFound)();
    }
}
